

export const waitForUmami = (maxWaitTime = 15000) => {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();

        const check = () => {
            if (window.umami && typeof window.umami.identify === 'function') {
                // console.log(`UMAMI - Ready after ${Date.now() - startTime}ms`);
                resolve(window.umami);
                return;
            }

            if (Date.now() - startTime > maxWaitTime) {
                reject(new Error('Umami not available after timeout'));
                return;
            }

            setTimeout(check, 200);
        };

        check();
    });
};

export async function trackPage(location: any, email: string) {
    await waitForUmami();
    // console.log(`tracking... ${location.pathname + location.search + `?user=${email}`}`);
    const eventName = (location.pathname + location.search).slice(0, 50);
    window.umami.track(eventName, {
        "email": email,
    });
}

export async function trackEvent(name: string, email: string, record?: Record<string, string>) {
    await waitForUmami();
    const eventName = (name + `?user=${email}`).slice(0, 50);
    window.umami.track(eventName, record);
}

